import request from '@/utils/request'

/**
 * 获取oss临时token
 *
 * @returns
 */
export function genOssTmpToken () {
  return request({
    url: '/getOssImgToken',
    method: 'get'
  })
}
